// extracted by mini-css-extract-plugin
export default {"inventoryCell":"Wj_x6hdnBEhbZBBcYpHd","green":"oF7TJzkPM23TV1ZBGCtd","red":"lsKjWxdT7C0DSAT2AcLe","grey":"mTCMfZmfrz7trBpAlkne"};